import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"
import { collection, addDoc } from "firebase/firestore"

const firebaseConfig = {
    apiKey: "AIzaSyBI4uY4udUhqtZMqwGcqq02XB1RBalVe98",
    authDomain: "zooop-app.firebaseapp.com",
    projectId: "zooop-app",
    storageBucket: "zooop-app.appspot.com",
    messagingSenderId: "23995635899",
    appId: "1:23995635899:web:e8f077ee3241fa8d82b19e",
    measurementId: "G-KYXHPJ7ZP9"
}

export const firebaseApp = initializeApp(firebaseConfig)

export const firebaseAuth = getAuth(firebaseApp)

export const fireStoreDB = getFirestore()
